import {AfterViewInit, TemplateRef, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FeatureTypeService} from '@catmodules/core/services/index';

/**
 * The timeout on when the provided content information are injected into there matching container templates
 * @type {number}
 */
const VIEW_INJECT_INTERVAL = 10;

/**
 * Abstract component to collect / provide the common used properties and event callbacks used
 * in one of the many default "welcome" component for a lot of Resource modifier views.
 */
export abstract class BaseWelcomeComponent implements AfterViewInit {
  form: FormGroup;
  title: string;
  selfLabel: string;

  isCompleted = false;
  createdEntity = null;

  labels = {};

  feature = null;
  @ViewChild('introduction') contentIntroduction: TemplateRef<any>;
  @ViewChild('properties') contentProperties: TemplateRef<any>;
  @ViewChild('completion') contentCompletion: TemplateRef<any>;

  contentRefs = {
    introduction: null,
    properties: null,
    completion: null,
  };

  constructor(){}

  ngAfterViewInit() {
    setTimeout(() => {
      this.contentRefs.introduction = this.contentIntroduction;
      this.contentRefs.properties = this.contentProperties;
      this.contentRefs.completion = this.contentCompletion;
    }, VIEW_INJECT_INTERVAL);
  }

  getFeature() {
    return this.feature;
  }

  setCurrentEntity(createdEntity: any) {
    this.createdEntity = createdEntity;
  }

  setIsCompleted(isCompleted: boolean) {
    this.isCompleted = isCompleted;
  }

  afterFeatureChanged(feature) {
  }

  resetFormResult(){
    this.setCurrentEntity(null);
    this.setIsCompleted(false);
  }

  abstract saveNewEntity();

  abstract validatePropertiesView();

  abstract get formIsReady();

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/shared/feature/create-form-wizards/base-welcome.component.ts